import { useDispatch } from "react-redux";
import { setSuggestNewSnapshot } from "../../reducers/askAI-reducer";
import { handleQuickAssist } from "../../actions/askAIAction";

/**
 * NewSnapshotBanner Component
 * Displays a subtle banner suggesting user to take a new photo
 * when Gemini detects the current image may be outdated
 */
const NewSnapshotBanner = ({ disabled = false }) => {
    const dispatch = useDispatch();

    const handleCaptureNew = () => {
        dispatch(setSuggestNewSnapshot(false));
        dispatch(handleQuickAssist(true));
    };

    const handleDismiss = () => {
        dispatch(setSuggestNewSnapshot(false));
    };

    return (
        <div className='askai-new-snapshot-banner'>
            <div className='askai-banner-content'>
                <span className='askai-banner-icon icon-camera'></span>
                <span className='askai-banner-text'>New photo recommended for better analysis</span>
            </div>
            <div className='askai-banner-actions'>
                <button className='btn btn-small askai-banner-btn' onClick={handleCaptureNew} disabled={disabled}>
                    <span className='btn-icon icon-camera'></span>
                    <span className='btn-text'>Capture</span>
                </button>
                <button className='btn btn-small askai-banner-dismiss' onClick={handleDismiss} disabled={disabled}>
                    <span className='icon-close'></span>
                </button>
            </div>
        </div>
    );
};

export default NewSnapshotBanner;
